module.exports = __webpack_public_path__ + "static/media/img_zendy01.aac76c96.jpeg";